'use strict';

angular.module('ecrd.queries').factory('QueriesService', [
    '$exceptionHandler',
    '$rootScope',
    'ErrorMessages',
    'Event',
    'gettext',
    'InetsysMessages',
    'Modal',
    'RecordDataService',
    'RecordQueriesService',
    'RecordService',
    'RecordsManagerService',
    'CrfService',
    function(
        $exceptionHandler,
        $rootScope,
        ErrorMessages,
        Event,
        gettext,
        InetsysMessages,
        Modal,
        RecordDataService,
        RecordQueriesService,
        RecordService,
        RecordsManagerService,
        CrfService
    ) {
        return {
            getFieldQueries: RecordQueriesService.getFieldQueries,
            createQuery: function(fieldId, listIndices) {
                // Allow others to stop this action before it is launched
                return Event.broadcast('discrepancyNotesActionStart', [fieldId, 'create'])
                    .then(function(event) {
                        if (!event.defaultPrevented) {
                            // Open form in modal
                            return Modal.open({
                                controller: 'FieldCreateQueryController',
                                controllerAs: '$ctrl',
                                templateUrl: 'modules/ecrd/components/field/queries/create-modal/content.html',
                                onlyActions: true,
                            }).closePromise
                                // 'Submit' button pressed - Call server to create note
                                .then(function(queryData) {
                                    var fieldUId = RecordDataService.getElementUID(fieldId, listIndices);
                                    var params = {
                                        recordId: RecordService.getId(),
                                        fieldUId: fieldUId.join('.'),
                                        text: queryData.text,
                                    };

                                    return RecordsManagerService.createQuery(params);
                                })
                                // Error
                                .catch(function(error) {
                                    // 'Cancel' button pressed - nothing to do
                                    if (error !== Modal.DISMISSED) {
                                        InetsysMessages.error({
                                            mode: 'modal',
                                            title: gettext('No se ha podido crear la nota de discrepancia'),
                                            body: ErrorMessages.get(error),
                                        });
                                    }

                                    throw error;
                                })
                                // Successfull call
                                .then(function() {
                                    // Success message
                                    InetsysMessages.success({
                                        title: gettext('Nueva nota de discrepancia creada'),
                                    });

                                    return RecordsManagerService.getQueries(RecordService.getId());
                                })
                                .then(function(recordQueries) {
                                    RecordQueriesService.load(recordQueries);
                                    // Trigger event: info updated
                                    $rootScope.$broadcast('EntityNotesUpdated');
                                });
                        }
                    })
                    .catch($exceptionHandler);
            },
            replyQuery: function(query) {
                var fieldId = CrfService.getElementIdByUID(query.fieldUId);

                // Allow others to stop this action before it is launched
                return Event.broadcast('discrepancyNotesActionStart', [fieldId, 'reply'])
                    .then(function(event) {
                        if (!event.defaultPrevented) {
                            // Open form in modal
                            return Modal.open({
                                controller: 'FieldReplyQueryController',
                                controllerAs: '$ctrl',
                                templateUrl: 'modules/ecrd/components/field/queries/reply-modal/content.html',
                                onlyActions: true,
                                resolve: {
                                    query: function() {
                                        return query;
                                    },
                                },
                            }).closePromise
                                // 'Submit' button pressed - Call server to reply note
                                .then(function(queryData) {
                                    var params = {
                                        queryId: query.id,
                                        status: queryData.status,
                                        text: queryData.text,
                                    };

                                    return RecordsManagerService.replyQuery(params);
                                })
                                // Error in server call
                                .catch(function(error) {
                                    // Error message
                                    if (error !== Modal.DISMISSED) {
                                        InetsysMessages.error({
                                            mode: 'modal',
                                            title: gettext('No se ha podido responder la nota de discrepancia'),
                                            body: ErrorMessages.get(error),
                                        });
                                    }

                                    throw error;
                                })
                                // Query replied
                                .then(function(response) { // eslint-disable-line no-unused-vars
                                    // initNotesData();
                                    // Success message
                                    InetsysMessages.success({
                                        title: gettext('Nota de discrepancia actualizada'),
                                    });

                                    return RecordsManagerService.getQueries(RecordService.getId());
                                })
                                .then(function(recordQueries) {
                                    RecordQueriesService.load(recordQueries);
                                    // Trigger event: info updated
                                    $rootScope.$broadcast('EntityNotesUpdated');
                                });
                        }
                    })
                    .catch($exceptionHandler);
            },
            closeQuery: function(query) {
                var fieldId = CrfService.getElementIdByUID(query.fieldUId);

                // Allow others to stop this action before it is launched
                return Event.broadcast('discrepancyNotesActionStart', [fieldId, 'close'])
                    .then(function(event) {
                        if (!event.defaultPrevented) {
                            // Open form in modal
                            return Modal.open({
                                controller: 'FieldCloseQueryController',
                                controllerAs: '$ctrl',
                                templateUrl: 'modules/ecrd/components/field/queries/close-modal/content.html',
                                onlyActions: true,
                                resolve: {
                                    query: function() {
                                        return query;
                                    },
                                },
                            }).closePromise
                                // 'Submit' button pressed - Call server to close note
                                .then(function(data) {
                                    // var fieldUId = RecordDataService.getElementUID(vm.fieldId, listIndices);
                                    var params = {
                                        queryId: query.id,
                                        // status: 'closed',
                                        text: data.text,
                                    };

                                    return RecordsManagerService.closeQuery(params);
                                })
                                // Error in server call
                                .catch(function(error) {
                                    if (error !== Modal.DISMISSED) {
                                        // Error message
                                        InetsysMessages.error({
                                            mode: 'modal',
                                            title: gettext('No se ha podido responder la nota de discrepancia'),
                                            body: ErrorMessages.get(error),
                                        });
                                    }

                                    throw error;
                                })
                                // Query closed
                                .then(function(response) { // eslint-disable-line no-unused-vars
                                    // Success message
                                    InetsysMessages.success({
                                        title: gettext('Nota de discrepancia actualizada'),
                                    });

                                    return RecordsManagerService.getQueries(RecordService.getId());
                                })
                                .then(function(recordQueries) {
                                    RecordQueriesService.load(recordQueries);
                                    // Trigger event: info updated
                                    $rootScope.$broadcast('EntityNotesUpdated');
                                });
                        }
                    })
                    .catch($exceptionHandler);
            },
        };
    }]);
